// ─── Qué PLOs puede evaluar una tarea signature ─────────────────────────────
//
// EL PROBLEMA. Marcar una tarea como evaluadora produce la marca 'E' de la
// matriz de alineación, y esa marca es lo que la auditoría cuenta para decidir
// si un resultado de aprendizaje está verificado. Pero la auditoría cuenta
// SÓLO los del CAP que el programa persigue.
//
// El selector ofrecía todos los PLOs del programa sin mirar el CAP. En un
// programa con dos juegos sembrados —cosa normal: la escalera copia el peldaño
// anterior— el coordinador podía marcar una tarea contra un PLO del BSC en un
// programa que va por el DEP. La tarea se guarda, la pantalla dice que todo
// salió bien, y la auditoría no cambia nunca. No hay forma de entender por qué.
//
// Es la misma falla que costó tiempo en el hub con los programas inactivos: la
// pantalla ofrece algo que el resto del sistema no va a honrar.

export interface PloOption {
  id: string;
  label: string;
  capCode: string;
  order: number;
}

/**
 * Los PLOs elegibles para una tarea signature de este programa.
 *
 * Con un CAP objetivo declarado, sólo los de ESE CAP: son los únicos cuya marca
 * 'E' va a contar. Sin CAP objetivo no hay contra qué auditar, así que se
 * devuelven todos —el programa todavía puede usarlos para su propio diseño— y
 * es la pantalla la que debe explicar que nada de esto llega a TMAI.
 */
export function eligiblePloOptions(
  options: readonly PloOption[],
  targetCapCode: string | undefined,
): PloOption[] {
  const eligible = targetCapCode
    ? options.filter((o) => o.capCode === targetCapCode)
    : [...options];
  return eligible.sort((a, b) => a.capCode.localeCompare(b.capCode) || a.order - b.order);
}
